export const snackbar = () => {
  const snackbar = document.querySelector('[js-snackbar]');
  const snackbarForce = document.querySelector('[js-snackbar-force]');
  const hideSnackbar = document.querySelector('[js-hide-snackbar]');
  const header = document.querySelector<HTMLElement>('header');
  const bodySnackbarClass = 'snackbar-active';

  if (!snackbar || !hideSnackbar || !header) {
    return;
  }

  hideSnackbar.addEventListener('click', () => {
    sessionStorage.setItem('hideSnackbar', 'true');
    snackbar.remove();
    document.body.classList.remove(bodySnackbarClass);
    adjustHeaderPosition();
  });

  if (!snackbarForce && sessionStorage.getItem('hideSnackbar')) {
    snackbar.remove();
  }

  /* Snackbar is on page, move header down */
  if (snackbar) {
    let ticking = false;

    document.body.classList.add(bodySnackbarClass);

    ['load', 'resize', 'scroll'].forEach((event) =>
      window.addEventListener(event, () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            adjustHeaderPosition();
            ticking = false;
          });
        }
        ticking = true;
      })
    );
  }

  /* <header> top position needs to be manaully adjusted when snackbar is on page as header is normally fixed to the top */
  const adjustHeaderPosition = () => {
    snackbar.removeAttribute('hidden');
    const viewportOffset = snackbar.getBoundingClientRect();

    const top = viewportOffset.bottom > 0 ? viewportOffset.bottom : 0;
    header.style.top = top.toString() + 'px';
  };
};
